"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AnalyseAudience;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _campaignCreatorContentHook = require("../../helpers/campaignCreatorContentHook");

var _semanticUiReact = require("semantic-ui-react");

var _LandingPageCard = _interopRequireDefault(require("./LandingPageCard"));

var _useFeatureAccessHook = require("../../helpers/useFeatureAccessHook");

var _index = require("../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function AnalyseAudience(_ref) {
  var imageOne = _ref.imageOne,
      imageTwo = _ref.imageTwo;
  var dispatch = (0, _reactRedux.useDispatch)();
  var analyseAudiencePermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.workflowPermission;
  });
  var campaignCreatorAccess = (0, _useFeatureAccessHook.useFeatureAccess)(analyseAudiencePermission);
  var pageTitle = (0, _campaignCreatorContentHook.usePageElement)('secondLandingPage', 'pageTitle');
  var subTitle = (0, _campaignCreatorContentHook.usePageElement)('secondLandingPage', 'subtitle');
  var firstImageText = (0, _campaignCreatorContentHook.usePageElement)('secondLandingPage', 'firstImageText');
  var secondImageText = (0, _campaignCreatorContentHook.usePageElement)('secondLandingPage', 'secondImageText');
  (0, _react.useEffect)(function () {
    dispatch((0, _index.featureAccess)());
  }, [dispatch]);

  if (!campaignCreatorAccess) {
    return '';
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    width: 12
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "landing-page"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "landing-page__title"
  }, pageTitle), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "landing-page__sub-title"
  }, subTitle), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    stackable: true,
    className: "landing-page__inner-grid"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    columns: 2
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement(_LandingPageCard["default"], {
    to: "/creative-briefs/quadrant-profile",
    disabled: true,
    image: imageOne,
    title: firstImageText
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement(_LandingPageCard["default"], {
    to: "/creative-briefs/audience-profiling",
    image: imageTwo,
    title: secondImageText
  }))))))));
}